// @generated by TypeGen from LogbookModel/Day.swift - DO NOT EDIT

import type { IAuditLogEdit } from "./AuditLogEdit"
import type { IDataRecord } from "./DataRecord"
import type { IDataRecordable } from "./DataRecord/DataRecordable"
import type { IDayWatchData } from "./Day/DayWatch"
import type { IEngineCalculations } from "./Engine"
import type { ILogbookModel, IModelCalculations } from "./Model"
import type { INote } from "./Note"
import type { INotable } from "./Note/Notable"
import type { INoteAttachment } from "./NoteAttachment"
import type { IDayCalculationsV2 } from "./Statistics/CalculationsV2"
import type { ICalculationResult, IStoredCalculationTimeseries } from "./StoredCalculation"
import type { ICalculated } from "./StoredCalculation/Calculated"
import type { IWeatherTimeseriesData } from "./Weather"

export interface IDay extends ICalculated<IDayCalculations>, INotable, IDataRecordable, ILogbookModel {
  id: number;
  cruiseId: number;
  tripId: number;
  accountId: number;
  shipId: number;
  createdAt: string;
  updatedAt: string;
  syncedAt?: string;
  comment?: string;
  crew?: number[];
  day: number;
  endLocation?: string;
  passengers?: number[];
  skipper?: number;
  startLocation?: string;
  timezone: number;
  data: string;
}

export interface IDayCalculations extends IModelCalculations {
  day?: number;
  daysRun?: number;
  distance?: number;
  distanceUnderEngine?: number;
  distanceUnderSails?: number;
  duration?: number;
  durationCruising?: number;
  durationPaused?: number;
  durationUnderEngine?: number;
  durationUnderSails?: number;
  endTime?: number;
  engines?: IEngineCalculations[];
  logs?: number;
  moonphase?: number;
  sog?: number;
  startTime?: number;
  sunrise?: string;
  sunset?: string;
  weatherTimeseries?: IStoredCalculationTimeseries<IWeatherTimeseriesData>;
}

export interface IDayData {
  watch?: IDayWatchData;
}

export interface IDayResponse {
  day: IDay;
  calculation?: ICalculationResult<IDayCalculations>;
  calculationV2?: ICalculationResult<IDayCalculationsV2>;
  auditLogEdits: IAuditLogEdit[];
}

export interface IDaysResponse {
  days: IDay[];
  calculations: ICalculationResult<IDayCalculations>[];
  calculationsV2: ICalculationResult<IDayCalculationsV2>[];
  notes?: INote[];
  attachments?: INoteAttachment[];
  dataRecords?: IDataRecord[];
  auditLogEdits: IAuditLogEdit[];
}

export type IDayParsed = Omit<IDay, "data"> & { dataParsed: IDayData };

export const Day = {
  parse(r: IDay): IDayParsed {
    return { ...r, dataParsed: r.data != null ? JSON.parse(r.data) : {} } as IDayParsed;
  },
};
